import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalPopoverPage } from "../modal-popover/modal-popover.page";
import { AppServiceService } from "../../../../api/app-service.service";
import consts from '../constatnts.json';

@Component({
  selector: 'web-footer',
  templateUrl: './web-footer.page.html',
  styleUrls: ['./web-footer.page.scss'],
})

export class WebFooterComponent implements OnInit {
  POPOVER_TYPES = consts.POPOVER_TYPES;
  public hostName = '';

  constructor(private modalController: ModalController, public appService: AppServiceService) { }

  ngOnInit() {
    this.hostName = window.location.hostname;
  }

  async openLoginPopUp() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'type': this.POPOVER_TYPES.LOGIN.TYPE,
        'title': this.POPOVER_TYPES.LOGIN.TITLE
      }
    });

    await modal.present();
  }

  async openPage(slug, title) {
    let componentPropsPre = null;
    if (slug === 'allergies_and_additives') {
      componentPropsPre = {
        'type': 'allergies_and_additives',
        'title': 'key.allergies_and_additives'
      };
    } else {
      componentPropsPre = {
        'type': 'pages',
        'title': title,
        'slug': slug
      }
    }
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: componentPropsPre
    });

    await modal.present();
  }
}